import {
  INGREDIENT_CATEGORY_SET_OUTLETS,
  INGREDIENT_CATEGORY_SET_CATEGORIES,
  INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL,
  INGREDIENT_CATEGORY_PAGE_REQUEST,
  INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD,
  INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN,
  INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN,
  INGREDIENT_CATEGORY_CATEGORIES_REQUEST,
  INGREDIENT_CATEGORY_SET_CURRENT_PAGE,
  INGREDIENT_CATEGORY_SET_TOTAL_PAGE,
  INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY,
  INGREDIENT_CATEGORY_ON_CLICK_CANCEL,
  INGREDIENT_CATEGORY_ON_CLICK_ROW,
  INGREDIENT_CATEGORY_SUBMIT_FORM,
  INGREDIENT_CATEGORY_SHOW_DELETE_MODAL,
  INGREDIENT_CATEGORY_HIDE_DELETE_MODAL,
  INGREDIENT_CATEGORY_DELETE_CATEGORY,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM,
  INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS,
  INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT,
  INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL,
  INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL,
  INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY,
  INGREDIENT_CATEGORY_SET_IS_SUBMITTING
} from './constants'

export function pageRequest () {
  return {type: INGREDIENT_CATEGORY_PAGE_REQUEST, payload: {}}
}

export function categoriesRequest (query, previousCategories) {
  return {type: INGREDIENT_CATEGORY_CATEGORIES_REQUEST, payload: {query, previousCategories}}
}

export function setCategories (categories) {
  return {type: INGREDIENT_CATEGORY_SET_CATEGORIES, payload: {categories}}
}

export function setOutlets (outlets) {
  return {type: INGREDIENT_CATEGORY_SET_OUTLETS, payload: {outlets}}
}

export function setCategoryDetail (category) {
  return {type: INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL, payload: {category}}
}

export function onChangeOutletIds (outletIds) {
  return {type: INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS, payload: {outletIds}}
}

export function onChangeKeyword (keyword) {
  return {type: INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD, payload: {keyword}}
}

export function onClickCreateCategory () {
  return {type: INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY, payload: {}}
}

export function openRightColumn () {
  return {type: INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN, payload: {}}
}

export function setCurrentPage (page) {
  return {type: INGREDIENT_CATEGORY_SET_CURRENT_PAGE, payload: {page}}
}

export function setTotalPage (page) {
  return {type: INGREDIENT_CATEGORY_SET_TOTAL_PAGE, payload: {page}}
}

export function onClickRow (category) {
  return {type: INGREDIENT_CATEGORY_ON_CLICK_ROW, payload: {category}}
}

export function onClickCancel () {
  return {type: INGREDIENT_CATEGORY_ON_CLICK_CANCEL, payload: {}}
}

export function submitForm (category, createAllOutlet, previousCategories, outletIds) {
  return {type: INGREDIENT_CATEGORY_SUBMIT_FORM, payload: {category, createAllOutlet, previousCategories, outletIds}}
}

export function showDeleteModal () {
  return {type: INGREDIENT_CATEGORY_SHOW_DELETE_MODAL, payload: {}}
}

export function hideDeleteModal () {
  return {type: INGREDIENT_CATEGORY_HIDE_DELETE_MODAL, payload: {}}
}

export function deleteCategory (category, categories) {
  return {type: INGREDIENT_CATEGORY_DELETE_CATEGORY, payload: {category, categories}}
}

export function onClickAssignToIngredient (category) {
  return {type: INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT, payload: {category}}
}

export function showAssignToIngredientModal () {
  return {type: INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL, payload: {}}
}

export function hideAssignToIngredientModal () {
  return {type: INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL, payload: {}}
}

export function cancelAssignToIngredient () {
  return {type: INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT, payload: {}}
}

export function assignToIngredientSetIngredients (ingredients) {
  return {type: INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS, payload: {ingredients}}
}

export function assignToIngredientSetCurrentPage (currentPage) {
  return {type: INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function assignToIngredientSetTotalPage (totalPage) {
  return {type: INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function assignToIngredientGetIngredientsRequest (params, previousIngredients) {
  return {type: INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST, payload: {params, previousIngredients}}
}

export function submitAssignToIngredient (data, category) {
  return {type: INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT, payload: {data, category}}
}

export function assignToIngredientFillForm (category, ingredients) {
  return {type: INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM, payload: {category, ingredients}}
}

export function assignToIngredientSetCategory (category) {
  return {type: INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY, payload: {category}}
}

export function setIsSubmitting (isSubmitting) {
  return {type: INGREDIENT_CATEGORY_SET_IS_SUBMITTING, payload: {isSubmitting}}
}



// WEBPACK FOOTER //
// ./app/actions/ingredients/category/index.js